export enum SaveBarMode {
  Disabled = 'disabled',
  OrderEdit = 'order-edit',
  CreateCampaign = 'campaign-add',
  FulfillmentOrderCreate = 'external-order-create',
}
